/// <reference path="../_references.ts"/>

module App.Administrative.PurchaseOrder {
	import Appointment = App.Appointments.Appointment;
	import SelectedAppointment = App.Appointments.SelectedAppointment;
	import TitleBarService = App.Helpers.TitleBarService;

	export class PurchaseOrderController {
		appointment: Appointment = null;
		po: PO = new PO();
		form: ng.IFormController;
		usingAt: boolean = null;
		isSaving: boolean = false;
		types: PurchaseOrderType[] = [];

		static $inject: string[] = ['SelectedAppointment', 'PurchaseOrderService', 'TitleBarService'];

		constructor(
			private SelectedAppointment: SelectedAppointment,
			private PurchaseOrderService: PurchaseOrderService,
			private TitleBarService: TitleBarService
		) {
			TitleBarService.set('Purchase Order');

			SelectedAppointment.getAppointment().then((appointment) => {
				this.setAppointment(appointment);
			}).catch((response) => {
				if (response === SelectedAppointment.NO_APPOINTMENT) {
					this.usingAt = false;
				}
				// TODO: Display an error?
			});

			PurchaseOrderService.getTypes().then(response => {
				this.types = response.data;
			});
		}

		setAppointment(appointment: Appointment) {
			this.appointment = appointment;
		}

		createPo() {
			this.isSaving = true;

			if(this.usingAt) {
				this.po.address = this.appointment.service_request.service_address.id;
				this.po.service_request = this.appointment.service_request.id;
			}

			this.PurchaseOrderService.create(this.po).then((response) => {
				this.po.id = response.data.id;
			}).finally(() => this.isSaving = false);
		}
	}
}
